import { useEffect, useRef } from "react";
import { useRouteTelemetry } from "../../hooks/telemetry/useRouteTelemetry";

export function RouteTelemetryBridge({ route, hash }) {
  const previousRouteIdRef = useRef(route.id);

  useRouteTelemetry({
    route,
    hash,
    previousRouteId: previousRouteIdRef.current,
  });

  useEffect(() => {
    previousRouteIdRef.current = route.id;
  }, [route.id]);

  return null;
}
